import {
    ChangeDetectionStrategy,
    Component,
    computed,
    input,
} from '@angular/core';
import { WorkflowStateBadgeComponent } from '@interacta-shared/ui-common';
import { IconComponent } from '@interacta-shared/ui-icons';
import { getFeedbackTaskStateStyle } from '@modules/feedback/models/feedback.utils';
import { UserNotificationEvent } from '@modules/notification/models/user-notification.model';
import { TranslatePipe } from '@ngx-translate/core';
import { UserNotificationComponent } from '../user-notification/user-notification.component';

@Component({
    selector: 'interacta-feedback-task-change-status-user-notification',
    imports: [
        UserNotificationComponent,
        WorkflowStateBadgeComponent,
        IconComponent,
        TranslatePipe,
    ],
    templateUrl: './feedback-task-change-status-notification.component.html',
    styles: ``,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FeedbackTaskChangeStatusNotificationComponent {
    notification = input.required<UserNotificationEvent>();

    readonly feedbackTaskFromStateStyle = computed(() => {
        const fromState =
            this.notification().lastTaskTransitionOperationDetail?.fromState;
        return fromState ? getFeedbackTaskStateStyle(fromState) : undefined;
    });

    readonly feedbackTaskToStateStyle = computed(() => {
        const toState =
            this.notification().lastTaskTransitionOperationDetail?.toState;
        return toState ? getFeedbackTaskStateStyle(toState) : undefined;
    });
}
